import type {GroupConfig, PayPeriod} from './types';

export interface PayPeriodInfo {
  label: string;
  /** Shown right after a price, e.g. "$9.99/month". */
  priceSuffix: string;
  /** Standalone, under a price. */
  each: string;
  total: string;
  adjective: string;
  e123PeriodId: number;
}

export const PAY_PERIODS: Record<PayPeriod, PayPeriodInfo> = {
  weekly: {
    label: 'Weekly',
    priceSuffix: '/week',
    each: 'per week',
    total: 'Weekly total',
    adjective: 'weekly',
    e123PeriodId: 8,
  },
  biweekly: {
    label: 'Bi-weekly',
    priceSuffix: '/2 weeks',
    each: 'every 2 weeks',
    total: 'Bi-weekly total',
    adjective: 'bi-weekly',
    e123PeriodId: 9,
  },
  semimonthly: {
    label: 'Semi-monthly',
    priceSuffix: ' twice a month',
    each: 'twice a month',
    total: 'Semi-monthly total',
    adjective: 'semi-monthly',
    e123PeriodId: 20,
  },
  monthly: {
    label: 'Monthly',
    priceSuffix: '/month',
    each: 'per month',
    total: 'Monthly total',
    adjective: 'monthly',
    e123PeriodId: 1,
  },
};

export function sitePayPeriod(group: Pick<GroupConfig, 'payPeriod'>): PayPeriodInfo {
  return PAY_PERIODS[group.payPeriod ?? 'weekly'];
}
